import React, { FunctionComponent } from "react";
import { County } from "../../../@types";

const CountyName: FunctionComponent<{
  county: County;
  className?: string;
}> = ({ county, className }) => (
  <p className={className}>
    {county.name}, {county.state}
  </p>
);

export default CountyName;
